import type { AsyncEnrollment, BootcampEnrollment, Enrollment } from './types';

export const isBootcamp = (enrollment: Enrollment): enrollment is BootcampEnrollment => enrollment.type === 'bootcamp';

export const isAsync = (enrollment: Enrollment): enrollment is AsyncEnrollment => enrollment.type === 'async';

